import { render, staticRenderFns } from "./UpdatePasswordForm.vue?vue&type=template&id=46ec2259&scoped=true"
import script from "./UpdatePasswordForm.vue?vue&type=script&lang=js"
export * from "./UpdatePasswordForm.vue?vue&type=script&lang=js"
import style0 from "./UpdatePasswordForm.vue?vue&type=style&index=0&id=46ec2259&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ec2259",
  null
  
)

export default component.exports